export interface EstimateRequest {
  address: string;
  addressToken?: string;
}

export interface HomeValueEstimate {
  formattedAddress: string;
  lowEstimate: number;
  highEstimate: number;
  compCount: number;
  currency: 'USD';
}

export type EstimateResult =
  | { status: 'covered'; estimate: HomeValueEstimate }
  | { status: 'no_coverage'; formattedAddress: string }
  | { status: 'error'; message: string; retryAfter?: number };

export interface EstimateProvider {
  readonly name: string;
  getEstimate(request: EstimateRequest): Promise<EstimateResult>;
}

export function estimateMidpoint(estimate: HomeValueEstimate): number {
  return Math.round((estimate.lowEstimate + estimate.highEstimate) / 2);
}
